import { DateFns } from "@/shared/date-fns";
import { DialogBaseComponent, DialogParams } from "@/shared/dialog-base.component";
import { DomainService } from "@/shared/domain.service";
import { Component } from "@angular/core";
import moment from "moment-mini";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

export interface UpdateDatesDialogParams extends DialogParams {
  updateDate: Date;
}

@Component({
  selector: "uni-update-ship-date-dialog",
  templateUrl: "./update-ship-date-dialog.component.html",
  standalone: false,
})
export class UpdateShipDateDialogComponent extends DialogBaseComponent<UpdateDatesDialogParams> {
  updateDate = new Date();
  today = new Date();

  constructor(
    public config: DynamicDialogConfig<UpdateDatesDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Update Expected Ship By Date From Manufacturers",
      width: "1100px",
      height: "650px",
    });
    this.prepare();
  }

  async prepare() {
    this.updateDate = this.params.updateDate;
    this.isPageReady = true;
  }

  cancel() {
    this.dialogRef.close(null);
  }

  ok() {
    this.dialogRef.close(this.updateDate);
  }

  okToUpdate() {
    // const d = DateFns.dateDiff(this.updateDate, this.today, "day");
    return this.updateDate && DateFns.dateDiff(this.updateDate, this.today, "day") <= 0;
  }
}
